import { parse, stringify } from 'query-string';
import type { RouteProps } from 'react-router';
import { getCurrentUser } from './react/services/CurrentUser';
import { isFeatureEnabled } from './react/services/Features';
// eslint-disable-next-line no-restricted-imports
import * as RR from './removed-routes';
import * as R from './routes';
import { getRedirectsForHR } from './routes-pairs';

type Redirect = [string, string | ((props: RouteProps) => string)];

const redirects: Redirect[] = [
    ['/', R.DASHBOARD],
    [RR.DASHBOARD, R.DASHBOARD],
    [RR.USER_DIRECTORY, R.PEOPLE_DIRECTORY],
    [RR.USER_CREATE, R.ADMIN_USERS_DIRECTORY_CREATE],
    [RR.YOUR_COMPANY_USER_CREATE, R.ADMIN_USERS_DIRECTORY_CREATE],
    [RR.YOUR_COMPANY_USERS_CREATE, R.ADMIN_USERS_DIRECTORY_CREATE],
    [RR.YOUR_COMPANY_USERS, R.ADMIN_USERS_DIRECTORY],
    [RR.REVIEW_CYCLE_OVERVIEW, R.ADMIN_REVIEWS_SELECT_CYCLE],
    [RR.REVIEW_CYCLE_EDIT, R.ADMIN_REVIEW_CYCLE_EDIT],
    [RR.ADMIN_REVIEWS_SETTINGS, R.ADMIN_REVIEWS_EMAILS],
    [RR.REVIEW_GRAPH_COMPANY, R.ADMIN_REVIEWS_SELECT_CYCLE],
    [RR.REVIEW_GRAPH_TEAM, R.REVIEWS_TEAM],
    [RR.REVIEW_GRAPH_COMPANY_WITH_CYCLE, R.ADMIN_REVIEW_GRAPH_WITH_CYCLE],
    [RR.REVIEW_NO_CYCLE, R.REVIEWS_TEAM],
    [RR.REVIEW_TEAM_WITH_CYCLE, R.REVIEWS_TEAM_CYCLE],
    [RR.MEETING_DASHBOARD, R.ADMIN_MEETINGS_INSIGHTS],
    [RR.OBJECTIVE_CYCLE_OVERVIEW, R.OBJECTIVES_COMPANY_CYCLES],
    [RR.OBJECTIVE_NO_CYCLE, R.OBJECTIVES_TEAM],
    [RR.OBJECTIVES_COMPANY_CYCLES, R.OBJECTIVES_COMPANY_CYCLES],
    [RR.OBJECTIVES_COMPANY_CYCLE, R.OBJECTIVES_COMPANY_CYCLE],
    [RR.ADMIN_PLATFORMS, R.ADMIN_MESSAGES],
    [RR.ADMIN_PLATFORMS_EDIT, R.ADMIN_MESSAGES],
    [RR.ADMIN_COMPANY_BASICS, R.SETTINGS_FEATURE_SELECTION],
    [RR.FEEDBACK_CYCLE_OVERVIEW, R.ADMIN_FEEDBACK_SELECT_CYCLE],
    [RR.ADMIN_FEEDBACK_SETTINGS, R.ADMIN_FEEDBACK_EMAILS],
    [RR.FEEDBACK_PERSONAL_CYCLE, R.ADMIN_FEEDBACK_REQUESTED],
    [RR.FEEDBACK_NO_CYCLE, R.FEEDBACK_USER_TEAM],
    [RR.FEEDBACK_PROVIDE_PREVIEW, R.FEEDBACK_PREVIEW_ZEN],
    [RR.FEEDBACK_TEMPLATE_OVERVIEW, R.ADMIN_FEEDBACK_REQUESTED_TEMPLATES],
    [RR.OBJECTIVE_BROWSER, handleObjectiveBrowser],
    [RR.YOUR_COMPANY_FEEDBACK_PERSONAL_CYCLE, R.ADMIN_FEEDBACK_REQUESTED],
    [RR.YOUR_COMPANY_FEEDBACK_PERSONAL_CYCLE_OLDER, R.ADMIN_FEEDBACK_REQUESTED],
    [RR.YOUR_TEAM_FEEDBACK_PERSONAL_CYCLE, R.FEEDBACK_USER_TEAM_ANYTIME],
    [R.USER_PROFILE_SHORT, () => R.USER_PROFILE_SHORT + '/' + getCurrentUser().id],
    [RR.MESSAGE_STREAM, R.PEOPLE_MESSAGES],
    [RR.OLD_SAMPLE_CONTENT_MGMT, R.SETTINGS_SAMPLE_CONTENT],
    [RR.NEW_USER_PROFILE, R.USER_PROFILE],
    [RR.OLD_USER_PROFILE, R.USER_PROFILE],
    [RR.OLD_ADMIN_EMAIL_MANAGE, R.SETTINGS_EMAILS],
    [RR.ENGAGEMENT_SYSTEM, R.DASHBOARD],
    [RR.ADMIN_BAMBOO, retainQuery(R.SETTINGS_IMPORT_BAMBOO)],
    [RR.ADMIN_BAMBOO_HISTORY, R.SETTINGS_IMPORT_BAMBOO_HISTORY],
    [RR.ADMIN_BAMBOO_PREVIEW, R.SETTINGS_IMPORT_BAMBOO_PREVIEW],
    [RR.ADMIN_BAMBOO_CONFIG, retainQuery(R.SETTINGS_IMPORT_BAMBOO_CONFIG)],
    [RR.ADMIN_GOOGLE_APPS_IMPORT, retainQuery(R.SETTINGS_IMPORT_GOOGLE_WORKSPACE)],
    [RR.ADMIN_SLACK_CONFIGURATION, retainQuery(R.SETTINGS_SLACK)],
    [RR.ADMIN_NAMELY, retainQuery(R.SETTINGS_IMPORT_NAMELY)],
    [RR.ADMIN_NAMELY_HISTORY, R.SETTINGS_IMPORT_NAMELY_HISTORY],
    [RR.ADMIN_NAMELY_PREVIEW, R.SETTINGS_IMPORT_NAMELY_PREVIEW],
    [RR.ADMIN_NAMELY_CONFIG, retainQuery(R.SETTINGS_IMPORT_NAMELY_CONFIG)],
    [RR.ADMIN_PERSONIO, retainQuery(R.SETTINGS_IMPORT_PERSONIO)],
    [RR.ADMIN_PERSONIO_HISTORY, R.SETTINGS_IMPORT_PERSONIO_HISTORY],
    [RR.ADMIN_PERSONIO_PREVIEW, R.SETTINGS_IMPORT_PERSONIO_PREVIEW],
    [RR.ADMIN_PERSONIO_CONFIG, retainQuery(R.SETTINGS_IMPORT_PERSONIO_CONFIG)],
    [RR.ADMIN_SAPLING, retainQuery(R.SETTINGS_IMPORT_KALLIDUS)],
    [RR.ADMIN_SAPLING_HISTORY, R.SETTINGS_IMPORT_KALLIDUS_HISTORY],
    [RR.ADMIN_SAPLING_PREVIEW, R.SETTINGS_IMPORT_KALLIDUS_PREVIEW],
    [RR.ADMIN_SAPLING_CONFIG, retainQuery(R.SETTINGS_IMPORT_KALLIDUS_CONFIG)],
    [RR.ADMIN_CALENDAR_INTEGRATION, retainQuery(R.SETTINGS_CALENDAR_INTEGRATION)],
    [RR.ADMIN_SAML, retainQuery(R.SETTINGS_SAML)],
    [RR.INTEGRATIONS_SAML, retainQuery(R.SETTINGS_SAML)],
    [RR.ADMIN_BADGES, R.ADMIN_PRAISE],
    [RR.INTEGRATIONS_SAPLING, R.SETTINGS_IMPORT_KALLIDUS],
    [RR.INTEGRATIONS_SAPLING_HISTORY, R.SETTINGS_IMPORT_KALLIDUS_HISTORY],
    [RR.INTEGRATIONS_SAPLING_PREVIEW, R.SETTINGS_IMPORT_KALLIDUS_PREVIEW],
    [RR.INTEGRATIONS_SAPLING_CONFIG, retainQuery(R.SETTINGS_IMPORT_KALLIDUS_CONFIG)],
    [RR.YOUR_COMPANY_MEETINGS_SETTINGS, R.ADMIN_MEETINGS_SETTINGS],
    [RR.YOUR_COMPANY_MEETINGS_INSIGHTS, R.ADMIN_MEETINGS_INSIGHTS],
    [RR.YOUR_COMPANY_MEETINGS_TEMPLATES, R.ADMIN_MEETINGS_TEMPLATES],
    [RR.YOUR_COMPANY_MEETINGS_TEMPLATES_CREATE, R.ADMIN_MEETINGS_TEMPLATES_CREATE],
    [RR.YOUR_COMPANY_MEETINGS_TEMPLATES_EDIT, R.ADMIN_MEETINGS_TEMPLATES_EDIT],
    [RR.YOUR_COMPANY_MEETINGS, R.MEETING_OVERVIEW],
    [RR.YOUR_COMPANY_MEETINGS_SHARED, R.MEETING_OVERVIEW_SHARED],
    [RR.YOUR_COMPANY_MEETINGS_SHARED_PAGE, R.MEETING_SHARED],
    [RR.YOUR_COMPANY_MEETINGS_SHARED_DEDICATED, R.MEETING_SHARED_DEDICATED],
    [RR.YOUR_COMPANY_MEETINGS_MY_TEMPLATES, R.MEETING_OVERVIEW_TEMPLATE],
    [RR.YOUR_COMPANY_MEETINGS_MY_TEMPLATES_CREATE, R.MEETING_TEMPLATES_CREATE],
    [RR.YOUR_COMPANY_MEETINGS_MY_TEMPLATES_EDIT, R.MEETING_TEMPLATES_EDIT],
    [RR.SURVEYS_CREATE, R.ADMIN_SURVEYS_CREATE],
    [RR.SURVEYS_EDIT, R.ADMIN_SURVEYS_EDIT],
    [RR.SURVEYS_COPY, R.ADMIN_SURVEYS_COPY],
    [RR.OBJECTIVE_CYCLE_CREATE, R.OBJECTIVE_CYCLE_CREATE],
    [RR.OBJECTIVE_CYCLE_EDIT, R.OBJECTIVE_CYCLE_EDIT],
    [RR.OBJECTIVE_CYCLE_COPY, R.OBJECTIVE_CYCLE_COPY],
    [RR.ADMIN_OBJECTIVES_SETTINGS, R.ADMIN_OBJECTIVES_EMAILS],
    [RR.YOUR_TEAM_MEETINGS, R.MEETING_OVERVIEW_TEAM_INSIGHTS],
    [RR.YOUR_TEAM_FEEDBACK_SELECT_CYCLE, R.FEEDBACK_USER_TEAM_CYCLES],
    [RR.YOUR_TEAM_FEEDBACK_WITH_CYCLE, R.FEEDBACK_USER_TEAM_SINGLE_CYCLE],
    [RR.YOUR_TEAM_FEEDBACK_REQUESTED, R.FEEDBACK_USER_TEAM_ANYTIME],
    [RR.YOUR_TEAM_OBJECTIVES, R.OBJECTIVES_TEAM],
    [RR.YOUR_TEAM_OBJECTIVES_LIST, R.OBJECTIVES_TEAM_LIST],
    [RR.YOUR_TEAM_OBJECTIVES_BROWSER, R.OBJECTIVES_TEAM_BROWSE],
    [RR.YOUR_TEAM_OBJECTIVES_SELECT_CYCLE, R.OBJECTIVES_TEAM_CYCLES],
    [RR.YOUR_TEAM_OBJECTIVES_OVERVIEW, R.OBJECTIVES_TEAM_CYCLE],
    [RR.YOUR_TEAM_REVIEWS_SELECT_CYCLE, R.REVIEWS_TEAM],
    [RR.YOUR_TEAM_REVIEWS_WITH_CYCLE, R.REVIEWS_TEAM_CYCLE],
    [RR.YOUR_TEAM, R.PEOPLE],
    [RR.YOUR_TEAM_ACTIVITY, R.PEOPLE_ACTIVITES],
    [RR.YOUR_TEAM_USERS, R.PEOPLE_TEAM],
    [RR.YOUR_TEAM_USERS_USER, R.PEOPLE_TEAM_USER],
    [RR.YOUR_COMPANY_OBJECTIVES, R.OBJECTIVES_COMPANY],
    [RR.YOUR_COMPANY_OBJECTIVES_HIERARCHY, R.OBJECTIVES_COMPANY_HIERARCY],
    [RR.YOUR_COMPANY_OBJECTIVES_CASCADE, R.OBJECTIVES_COMPANY_CASCADE],
    [RR.YOUR_COMPANY_OBJECTIVES_LIST, R.OBJECTIVES_COMPANY_LIST],
    [RR.YOUR_COMPANY_OBJECTIVES_BROWSER, R.OBJECTIVES_COMPANY_BROWSE],
    [RR.YOUR_COMPANY, R.PEOPLE],
    [RR.YOUR_COMPANY_ACTIVITY, R.PEOPLE_ACTIVITES],
    [RR.YOUR_COMPANY_MESSAGES, R.PEOPLE_MESSAGES],
    [RR.YOUR_COMPANY_OBJECTIVES_SELECT_CYCLE, R.OBJECTIVES_COMPANY_CYCLES],
    [RR.YOUR_COMPANY_OBJECTIVES_OVERVIEW, R.OBJECTIVES_COMPANY_CYCLE],
    [RR.FEEDBACK_CYCLE_CREATE_NEW, R.ADMIN_FEEDBACK_CYCLE_CREATE],
    [RR.FEEDBACK_CYCLE_COPY_NEW, R.ADMIN_FEEDBACK_CYCLE_COPY],
    [RR.YOUR_COMPANY_FEEDBACK_SELECT_CYCLE, R.ADMIN_FEEDBACK_SELECT_CYCLE],
    [RR.YOUR_COMPANY_FEEDBACK_WITH_CYCLE, R.ADMIN_FEEDBACK_WITH_CYCLE],
    [RR.FEEDBACK_CYCLE_EDIT_NEW, R.ADMIN_FEEDBACK_CYCLE_EDIT],
    [RR.YOUR_COMPANY_FEEDBACK_REQUESTED, R.ADMIN_FEEDBACK_REQUESTED],
    [RR.YOUR_COMPANY_FEEDBACK_REQUESTED_TEMPLATES, R.ADMIN_FEEDBACK_REQUESTED_TEMPLATES],
    [RR.YOUR_COMPANY_FEEDBACK_REQUESTED_SETTINGS, R.ADMIN_FEEDBACK_REQUESTED_SETTINGS],
    [RR.REVIEW_CYCLE_CREATE, R.ADMIN_REVIEW_CYCLE_CREATE],
    [RR.REVIEW_CYCLE_COPY, R.ADMIN_REVIEW_CYCLE_COPY],
    [RR.YOUR_COMPANY_PRAISE, R.ADMIN_PRAISE],
    [RR.YOUR_COMPANY_REVIEWS_SELECT_CYCLE, R.ADMIN_REVIEWS_SELECT_CYCLE],
    [RR.YOUR_COMPANY_REVIEWS_QUESTIONNAIRES, R.ADMIN_REVIEWS_QUESTIONNAIRES],
    [RR.YOUR_COMPANY_REVIEWS_WITH_CYCLE, R.ADMIN_REVIEWS_WITH_CYCLE],
    [RR.YOUR_COMPANY_SURVEYS, R.YOUR_SURVEYS_SHARED],
    [RR.YOUR_COMPANY_SURVEYS_WITH_SURVEY, R.YOUR_SURVEYS_SHARED_WITH_SURVEY],
    [RR.YOUR_COMPANY_SURVEYS_WITH_SURVEY_PRINT, R.YOUR_SURVEYS_SHARED_WITH_SURVEY_PRINT],
    [RR.ADMIN_V2_MEETINGS, R.ADMIN_MEETINGS],
    [RR.ADMIN_V2_MEETINGS_INSIGHTS, R.ADMIN_MEETINGS_INSIGHTS],
    [RR.ADMIN_V2_MEETINGS_SETTINGS, R.ADMIN_MEETINGS_SETTINGS],
    [RR.ADMIN_V2_MEETINGS_TEMPLATES, R.ADMIN_MEETINGS_TEMPLATES],
    [RR.ADMIN_V2_MEETINGS_TEMPLATES_CREATE, R.ADMIN_MEETINGS_TEMPLATES_CREATE],
    [RR.ADMIN_V2_MEETINGS_TEMPLATES_EDIT, R.ADMIN_MEETINGS_TEMPLATES_EDIT],
    [RR.ADMIN_V2_PRAISE, R.ADMIN_PRAISE],
    [RR.ADMIN_V2_SURVEYS, R.ADMIN_SURVEYS],
    [RR.ADMIN_V2_SURVEYS_WITH_SURVEY, R.ADMIN_SURVEYS_WITH_SURVEY],
    [RR.ADMIN_V2_SURVEYS_WITH_SURVEY_PRINT, R.ADMIN_SURVEYS_WITH_SURVEY_PRINT],
    [RR.ADMIN_V2_SURVEYS_CREATE, R.ADMIN_SURVEYS_CREATE],
    [RR.ADMIN_V2_SURVEYS_EDIT, R.ADMIN_SURVEYS_EDIT],
    [RR.ADMIN_V2_SURVEYS_COPY, R.ADMIN_SURVEYS_COPY],
    [RR.ADMIN_V2_OBJECTIVES_SELECT_CYCLE, R.ADMIN_OBJECTIVES_SELECT_CYCLE],
    [RR.ADMIN_V2_OBJECTIVES_CYCLE_OVERVIEW, R.ADMIN_OBJECTIVES_CYCLE_OVERVIEW],
    [RR.ADMIN_V2_OBJECTIVE_CYCLE_CREATE, R.OBJECTIVE_CYCLE_CREATE],
    [RR.ADMIN_V2_OBJECTIVE_CYCLE_EDIT, R.OBJECTIVE_CYCLE_EDIT],
    [RR.ADMIN_V2_OBJECTIVE_CYCLE_COPY, R.OBJECTIVE_CYCLE_COPY],
    [RR.ADMIN_V2_FEEDBACK_SELECT_CYCLE, R.ADMIN_FEEDBACK_SELECT_CYCLE],
    [RR.ADMIN_V2_FEEDBACK_WITH_CYCLE, R.ADMIN_FEEDBACK_WITH_CYCLE],
    [RR.ADMIN_V2_FEEDBACK_CYCLE_CREATE, R.ADMIN_FEEDBACK_CYCLE_CREATE],
    [RR.ADMIN_V2_FEEDBACK_CYCLE_EDIT, R.ADMIN_FEEDBACK_CYCLE_EDIT],
    [RR.ADMIN_V2_FEEDBACK_CYCLE_COPY, R.ADMIN_FEEDBACK_CYCLE_COPY],
    [RR.ADMIN_V2_FEEDBACK_TEMPLATES, R.ADMIN_FEEDBACK_TEMPLATES],
    [RR.ADMIN_V2_FEEDBACK_REQUESTED, R.ADMIN_FEEDBACK_REQUESTED],
    [RR.ADMIN_V2_FEEDBACK_REQUESTED_TEMPLATES, R.ADMIN_FEEDBACK_REQUESTED_TEMPLATES],
    [RR.ADMIN_V2_FEEDBACK_REQUESTED_SETTINGS, R.ADMIN_FEEDBACK_REQUESTED_SETTINGS],
    [RR.ADMIN_V2_REVIEWS_SELECT_CYCLE, R.ADMIN_REVIEWS_SELECT_CYCLE],
    [RR.ADMIN_V2_REVIEWS_QUESTIONNAIRES, R.ADMIN_REVIEWS_QUESTIONNAIRES],
    [RR.ADMIN_V2_REVIEWS_WITH_CYCLE, R.ADMIN_REVIEWS_WITH_CYCLE],
    [RR.ADMIN_V2_REVIEW_CYCLE_CREATE, R.ADMIN_REVIEW_CYCLE_CREATE],
    [RR.ADMIN_V2_REVIEW_CYCLE_EDIT, R.ADMIN_REVIEW_CYCLE_EDIT],
    [RR.ADMIN_V2_REVIEW_CYCLE_COPY, R.ADMIN_REVIEW_CYCLE_COPY],
    [RR.ADMIN_V2_REVIEW_GRAPH_WITH_CYCLE, R.ADMIN_REVIEW_GRAPH_WITH_CYCLE],
    [RR.ADMIN_V2_USERS_DIRECTORY, R.ADMIN_USERS_DIRECTORY],
    [RR.ADMIN_V2_USERS_DIRECTORY_CREATE, R.ADMIN_USERS_DIRECTORY_CREATE],
    [RR.ADMIN_V2_MESSAGES, R.ADMIN_MESSAGES],
    [RR.ADMIN_V2_DASHBOARD, R.ADMIN_DASHBOARD],
    [RR.ADMIN_OVERVIEW, R.SETTINGS],
    [RR.ADMIN_FEATURE_SELECTION, R.SETTINGS_FEATURE_SELECTION],
    [RR.ADMIN_REPORT_EMAILS, R.SETTINGS_EMAIL_REPORTS],
    [RR.ADMIN_MAIL_LOG, R.SETTINGS_MAIL_LOG],
    [RR.ADMIN_BOUNCED_EMAILS, R.SETTINGS_BOUNCED_EMAILS],
    [RR.ADMIN_MESSAGE_STATISTICS, R.SETTINGS_MESSAGE_STATISTICS],
    [RR.ADMIN_MERGE_USERS, R.SETTINGS_MERGE_USERS],
    [RR.ADMIN_OBJECTIVE_CATEGORIES, R.SETTINGS_OBJECTIVE_CATEGORIES],
    [RR.ADMIN_OBJECTIVE_RATINGS, R.SETTINGS_OBJECTIVE_RATINGS],
    [RR.ADMIN_PAYMENT_DETAILS, R.SETTINGS_PAYMENT_DETAILS],
    [RR.ADMIN_BILLING, R.SETTINGS_BILLING],
    [RR.ADMIN_BILLING_CHECKOUT, R.SETTINGS_CHECKOUT],
    [RR.ADMIN_BILLING_CHECKOUT_STEP, R.SETTINGS_CHECKOUT_STEP],
    [RR.ADMIN_CSV_IMPORT, retainQuery(R.SETTINGS_CSV_IMPORT)],
    [RR.ADMIN_EMAIL_MANAGE, R.SETTINGS_EMAILS],
    [RR.ADMIN_HELPFUL_RESOURCES, R.SETTINGS_HELPFUL_RESOURCES],
    [RR.ADMIN_SAMPLE_CONTENT, R.SETTINGS_SAMPLE_CONTENT],
    [RR.ADMIN_SAMPLE_CONTENT_PROGRESS, R.SETTINGS_SAMPLE_CONTENT_PROGRESS],
    [RR.ADMIN_HIP_CHAT, R.SETTINGS_HIP_CHAT],
    [RR.ADMIN_DESIGN, R.SETTINGS_DESIGN],
    [RR.ADMIN_SETTINGS_COMPANY, R.SETTINGS_COMPANY],
    [RR.ADMIN_DATETIME, R.SETTINGS_COMPANY],
    [RR.ADMIN_SETTINGS_DATETIME, R.SETTINGS_COMPANY],
    [RR.ADMIN_CUSTOM_WORDING, R.SETTINGS_CUSTOM_WORDING],
    [RR.ADMIN_SETTINGS_AUTOMATIONS, R.SETTINGS_AUTOMATIONS],
    [RR.ADMIN_SETTINGS_FEATURE_SELECTION, R.SETTINGS_FEATURE_SELECTION],
    [RR.ADMIN_SETTINGS_REPORT_EMAILS, R.SETTINGS_EMAIL_REPORTS],
    [RR.ADMIN_SETTINGS_MAIL_LOG, R.SETTINGS_MAIL_LOG],
    [RR.ADMIN_SETTINGS_BOUNCED_EMAILS, R.SETTINGS_BOUNCED_EMAILS],
    [RR.ADMIN_SETTINGS_MESSAGE_STATISTICS, R.SETTINGS_MESSAGE_STATISTICS],
    [RR.ADMIN_SETTINGS_MERGE_USERS, R.SETTINGS_MERGE_USERS],
    [RR.ADMIN_SETTINGS_OBJECTIVE_CATEGORIES, R.SETTINGS_OBJECTIVE_CATEGORIES],
    [RR.ADMIN_SETTINGS_OBJECTIVE_RATINGS, R.SETTINGS_OBJECTIVE_RATINGS],
    [RR.ADMIN_SETTINGS_PAYMENT_DETAILS, R.SETTINGS_PAYMENT_DETAILS],
    [RR.ADMIN_SETTINGS_BILLING, R.SETTINGS_BILLING],
    [RR.ADMIN_SETTINGS_CHECKOUT, R.SETTINGS_CHECKOUT],
    [RR.ADMIN_SETTINGS_CHECKOUT_STEP, R.SETTINGS_CHECKOUT_STEP],
    [RR.ADMIN_SETTINGS_BADGES, R.ADMIN_PRAISE],
    [RR.ADMIN_SETTINGS_EMAILS, R.SETTINGS_EMAILS],
    [RR.ADMIN_SETTINGS_HELPFUL_RESOURCES, R.SETTINGS_HELPFUL_RESOURCES],
    [RR.ADMIN_SETTINGS_SAMPLE_CONTENT, R.SETTINGS_SAMPLE_CONTENT],
    [RR.ADMIN_SETTINGS_SAMPLE_CONTENT_PROGRESS, R.SETTINGS_SAMPLE_CONTENT_PROGRESS],
    [RR.ADMIN_SETTINGS_HIP_CHAT, R.SETTINGS_HIP_CHAT],
    [RR.ADMIN_SETTINGS_DESIGN, R.SETTINGS_DESIGN],
    [RR.ADMIN_SETTINGS_CUSTOM_WORDING, R.SETTINGS_CUSTOM_WORDING],
    [RR.ADMIN_SETTINGS_CSV, R.SETTINGS_CSV],
    [RR.ADMIN_SETTINGS_CSV_HISTORY, R.SETTINGS_CSV_HISTORY],
    [RR.ADMIN_SETTINGS_CSV_CONFIG, R.SETTINGS_CSV_CONFIG],
    [RR.ADMIN_SETTINGS_CSV_IMPORT, R.SETTINGS_CSV_IMPORT],
    [RR.ADMIN_DELETE_COMPANY, R.DELETE_COMPANY],
    [RR.ADMIN_OBJECTIVE_CYCLE_CREATE, R.OBJECTIVE_CYCLE_CREATE],
    [RR.ADMIN_OBJECTIVE_CYCLE_EDIT, R.OBJECTIVE_CYCLE_EDIT],
    [RR.ADMIN_OBJECTIVE_CYCLE_COPY, R.OBJECTIVE_CYCLE_COPY],
    [RR.INTEGRATIONS_GOOGLE_APPS_IMPORT, R.SETTINGS_IMPORT_GOOGLE_WORKSPACE],
    [RR.INTEGRATIONS_ADMIN_GOOGLE_APPS_IMPORT, R.SETTINGS_IMPORT_GOOGLE_WORKSPACE],
    [RR.INTEGRATIONS_BAMBOO, R.SETTINGS_IMPORT_BAMBOO],
    [RR.INTEGRATIONS_BAMBOO_HISTORY, R.SETTINGS_IMPORT_BAMBOO_HISTORY],
    [RR.INTEGRATIONS_BAMBOO_PREVIEW, R.SETTINGS_IMPORT_BAMBOO_PREVIEW],
    [RR.INTEGRATIONS_BAMBOO_CONFIG, retainQuery(R.SETTINGS_IMPORT_BAMBOO_CONFIG)],
    [RR.INTEGRATIONS_GOOGLE_WORKSPACE, R.SETTINGS_IMPORT_GOOGLE_WORKSPACE],
    [RR.INTEGRATIONS_GOOGLE_WORKSPACE_HISTORY, R.SETTINGS_IMPORT_GOOGLE_WORKSPACE_HISTORY],
    [RR.INTEGRATIONS_GOOGLE_WORKSPACE_PREVIEW, R.SETTINGS_IMPORT_GOOGLE_WORKSPACE_PREVIEW],
    [RR.INTEGRATIONS_GOOGLE_WORKSPACE_CONFIG, retainQuery(R.SETTINGS_IMPORT_GOOGLE_WORKSPACE_CONFIG)],
    [RR.INTEGRATIONS_SLACK, R.SETTINGS_SLACK],
    [RR.INTEGRATIONS_NAMELY, R.SETTINGS_IMPORT_NAMELY],
    [RR.INTEGRATIONS_NAMELY_HISTORY, R.SETTINGS_IMPORT_NAMELY_HISTORY],
    [RR.INTEGRATIONS_NAMELY_PREVIEW, R.SETTINGS_IMPORT_NAMELY_PREVIEW],
    [RR.INTEGRATIONS_NAMELY_CONFIG, R.SETTINGS_IMPORT_NAMELY_CONFIG],
    [RR.INTEGRATIONS_PERSONIO, R.SETTINGS_IMPORT_PERSONIO],
    [RR.INTEGRATIONS_PERSONIO_HISTORY, R.SETTINGS_IMPORT_PERSONIO_HISTORY],
    [RR.INTEGRATIONS_PERSONIO_PREVIEW, R.SETTINGS_IMPORT_PERSONIO_PREVIEW],
    [RR.INTEGRATIONS_PERSONIO_CONFIG, R.SETTINGS_IMPORT_PERSONIO_CONFIG],
    [RR.INTEGRATIONS_KALLIDUS, R.SETTINGS_IMPORT_KALLIDUS],
    [RR.INTEGRATIONS_KALLIDUS_HISTORY, R.SETTINGS_IMPORT_KALLIDUS_HISTORY],
    [RR.INTEGRATIONS_KALLIDUS_PREVIEW, R.SETTINGS_IMPORT_KALLIDUS_PREVIEW],
    [RR.INTEGRATIONS_KALLIDUS_CONFIG, R.SETTINGS_IMPORT_KALLIDUS_CONFIG],
    [RR.INTEGRATIONS_CALENDAR_INTEGRATION, R.SETTINGS_CALENDAR_INTEGRATION],
    [RR.INTEGRATIONS_WORKDAY, R.SETTINGS_IMPORT_WORKDAY],
    [RR.INTEGRATIONS_WORKDAY_HISTORY, R.SETTINGS_IMPORT_WORKDAY_HISTORY],
    [RR.INTEGRATIONS_WORKDAY_PREVIEW, R.SETTINGS_IMPORT_WORKDAY_PREVIEW],
    [RR.INTEGRATIONS_WORKDAY_CONFIG, R.SETTINGS_IMPORT_WORKDAY_CONFIG],
    [RR.INTEGRATIONS_SFTP, R.SETTINGS_IMPORT_SFTP],
    [RR.INTEGRATIONS_SFTP_HISTORY, R.SETTINGS_IMPORT_SFTP_HISTORY],
    [RR.INTEGRATIONS_SFTP_CONFIG, R.SETTINGS_IMPORT_SFTP_CONFIG],
    [RR.INTEGRATIONS_CUSTOM_CSV, R.SETTINGS_IMPORT_CUSTOM_CSV],
    [RR.INTEGRATIONS_CUSTOM_CSV_HISTORY, R.SETTINGS_IMPORT_CUSTOM_CSV_HISTORY],
    [RR.INTEGRATIONS_CUSTOM_CSV_PREVIEW, R.SETTINGS_IMPORT_CUSTOM_CSV_PREVIEW],
    [RR.INTEGRATIONS_CUSTOM_CSV_CONFIG, R.SETTINGS_IMPORT_CUSTOM_CSV_CONFIG],
    [RR.INTEGRATIONS_WORKABLE, R.SETTINGS_IMPORT_WORKABLE],
    [RR.INTEGRATIONS_WORKABLE_HISTORY, R.SETTINGS_IMPORT_WORKABLE_HISTORY],
    [RR.INTEGRATIONS_WORKABLE_PREVIEW, R.SETTINGS_IMPORT_WORKABLE_PREVIEW],
    [RR.INTEGRATIONS_WORKABLE_CONFIG, R.SETTINGS_IMPORT_WORKABLE_CONFIG],
    [RR.RETENTION, R.ADMIN_INSIGHTS],
    [RR.ADMIN_RETENTION, R.ADMIN_INSIGHTS],
    [RR.ADMIN_USERSETTINGS, R.SETTINGS_USERSETTINGS],
    [RR.ADMIN_V2_AUTOMATIONS, R.HR_AUTOMATIONS],
    [RR.SETTINGS_ANYTIME_FEEDBACK, R.SETTINGS_FEEDBACK_ANYTIME_GENERAL],
    [RR.SETTINGS_CYCLE_FEEDBACK, R.FEEDBACK_USER_COMPANY_TEMPLATES],
    [RR.SETTINGS_REVIEWS, R.REVIEWS_COMPANY_TEMPLATES],
    ...getGuestRedirects(),
    ...getRedirectsForHR(),
    ...getAdminNavRefreshRedirects(),
];

export default redirects;

export const renderLastRedirects: Redirect[] = [
    [RR.YOUR_SURVEYS_WITH_SURVEY, retainQuery(R.YOUR_SURVEYS_ANSWER_SURVEY)],
];

function handleObjectiveBrowser({ location }: RouteProps) {
    const { select, ...queryParams } = parse(location?.search ?? '');

    if (!select || select === 'me') {
        const targetRoute = isFeatureEnabled('FEATURE_adminNavigationRefresh') ? R.OBJECTIVES_YOUR : R.OBJECTIVES;
        return addQueryParams(targetRoute, queryParams);
    }

    if (select === 'all') {
        return R.OBJECTIVES_TEAM_LIST;
    }
    if (select === 'team' || select === 'coworkers') {
        return R.OBJECTIVES_TEAM_LIST;
    }

    const id = select === 'manager' ? getCurrentUser().managerId : select;
    return `/user/${id}?tab=objectives`;
}

function addQueryParams(path: string, params: Record<string, string>) {
    return path + '?' + stringify(params);
}

function getGuestRedirects(): Redirect[] {
    const user = getCurrentUser();
    if (!user || !user.isGuest) {
        return [];
    }

    return [
        [R.DASHBOARD, R.FEEDBACK_USER],
        [R.DASHBOARD_ITEM, R.FEEDBACK_USER],
        ...(isFeatureEnabled('FEATURE_adminNavigationRefresh')
            ? ([[R.FEEDBACK_USER + '?tab=todo', R.FEEDBACK_USER_TODO]] satisfies Redirect[])
            : []),
    ];
}

function getAdminNavRefreshRedirects(): Redirect[] {
    const navRefreshDirects: Redirect[] = [
        [R.ADMIN_INSIGHTS, R.INSIGHTS],
        [R.ADMIN_INSIGHTS + '/:subpage', R.INSIGHTS + '/:subpage'],
        [R.ADMIN_USERS_DIRECTORY, retainQuery(R.PEOPLE_DIRECTORY)],
        [R.ADMIN_SURVEYS, R.YOUR_SURVEYS_COMPANY],
        [R.ADMIN_SURVEYS_CREATE, R.YOUR_SURVEYS_COMPANY_CREATE],
        [R.ADMIN_SURVEYS_EDIT, R.YOUR_SURVEYS_COMPANY_EDIT],
        [R.ADMIN_SURVEYS_COPY, R.YOUR_SURVEYS_COMPANY_COPY],
        [R.ADMIN_SURVEYS_WITH_SURVEY, R.YOUR_SURVEYS_COMPANY_WITH_SURVEY],
        [R.ADMIN_FEEDBACK_CYCLE_CREATE, R.FEEDBACK_USER_COMPANY_CYCLE_CREATE],
        [R.ADMIN_FEEDBACK_CYCLE_EDIT, R.FEEDBACK_USER_COMPANY_CYCLE_EDIT],
        [R.ADMIN_FEEDBACK_CYCLE_COPY, R.FEEDBACK_USER_COMPANY_CYCLE_COPY],
        [R.ADMIN_FEEDBACK_SELECT_CYCLE, R.FEEDBACK_USER_COMPANY_CYCLES],
        [R.ADMIN_FEEDBACK_REQUESTED, R.FEEDBACK_USER_COMPANY_ANYTIME],
        [R.ADMIN_REVIEW_CYCLE_CREATE, R.REVIEWS_COMPANY_CYCLE_CREATE],
        [R.ADMIN_REVIEW_CYCLE_COPY, R.REVIEWS_COMPANY_CYCLE_COPY],
        [R.ADMIN_REVIEW_CYCLE_EDIT, R.REVIEWS_COMPANY_CYCLE_EDIT],
        [R.ADMIN_REVIEWS_SELECT_CYCLE, R.REVIEWS_COMPANY],
        [R.ADMIN_REVIEWS_COMPARE_CYCLES, retainQuery(R.REVIEWS_COMPANY_COMPARE_CYCLES)],
        [R.ADMIN_REVIEWS_QUESTIONNAIRES, R.REVIEWS_COMPANY_TEMPLATES],
        [R.ADMIN_OBJECTIVES_SELECT_CYCLE, R.OBJECTIVES_COMPANY_CYCLES],
        // using a function here to avoid reverse for old nav
        [R.ADMIN_OBJECTIVES_CYCLE_OVERVIEW, () => R.OBJECTIVES_COMPANY_CYCLE],
        [R.ADMIN_PRAISE_EMAILS, R.SETTINGS_EMAILS],
        [R.ADMIN_REVIEWS_EMAILS, R.SETTINGS_EMAILS],
        [R.ADMIN_FEEDBACK_EMAILS, R.SETTINGS_EMAILS],
        [R.ADMIN_MEETINGS_EMAILS, R.SETTINGS_EMAILS],
        [R.ADMIN_MESSAGES_EMAILS, R.SETTINGS_EMAILS],
        [R.ADMIN_OBJECTIVES_EMAILS, R.SETTINGS_EMAILS],
        [R.ADMIN_FEEDBACK_REQUESTED_EMAILS, R.SETTINGS_EMAILS],
        [R.ADMIN_REVIEWS_WITH_CYCLE, R.REVIEWS_COMPANY_CYCLE],
        [R.ADMIN_FEEDBACK_WITH_CYCLE, R.FEEDBACK_USER_COMPANY_SINGLE_CYCLE],
        [R.ADMIN_PRAISE, R.SETTINGS_PRAISE],
        [R.ADMIN_MEETINGS_SETTINGS, R.SETTINGS_MEETINGS],
        [R.ADMIN_FEEDBACK_TEMPLATES, R.FEEDBACK_USER_COMPANY_TEMPLATES],
        [R.ADMIN_FEEDBACK_REQUESTED_AUTOMATIONS, R.SETTINGS_FEEDBACK_ANYTIME_AUTOMATIONS],
        [R.ADMIN_FEEDBACK_REQUESTED_SETTINGS, R.SETTINGS_FEEDBACK_ANYTIME_GENERAL],
        [R.ADMIN_FEEDBACK_REQUESTED_TEMPLATES, R.FEEDBACK_USER_COMPANY_TEMPLATES],
        [R.ADMIN_MEETINGS_INSIGHTS, R.MEETING_OVERVIEW_COMPANY_INSIGHTS],
        [R.ADMIN_MEETINGS, R.MEETING_OVERVIEW_COMPANY_INSIGHTS],
        [R.ADMIN_EARLY_ACCESS_FEATURE, R.COMING_SOON_FEATURE],
        [R.ADMIN_EARLY_ACCESS, R.COMING_SOON],
        [R.MEETING_OVERVIEW_TEMPLATE, R.MEETING_OVERVIEW_TEMPLATES],
        [R.ADMIN_MEETINGS_TEMPLATES, R.MEETING_OVERVIEW_TEMPLATES],
        [R.MEETING_TEMPLATES_CREATE, R.MEETING_OVERVIEW_TEMPLATES_CREATE_PERSONAL],
        [R.ADMIN_MEETINGS_TEMPLATES_CREATE, R.MEETING_OVERVIEW_TEMPLATES_CREATE_COMPANY],
        [R.MEETING_TEMPLATES_EDIT, R.MEETING_OVERVIEW_TEMPLATES_EDIT_PERSONAL],
        [R.ADMIN_MEETINGS_TEMPLATES_EDIT, R.MEETING_OVERVIEW_TEMPLATES_EDIT_COMPANY],
        [R.HR_AUTOMATIONS, R.SETTINGS_AUTOMATIONS],
        [R.ADMIN_INTEGRATIONS, R.SETTINGS_IMPORT],
        [R.FEEDBACK_USER, R.FEEDBACK_USER_FOR_YOU],
        [R.OBJECTIVES, R.OBJECTIVES_YOUR],
        [R.MEETING_OVERVIEW, R.MEETING_OVERVIEW_YOUR],
        [R.ADMIN_USERS_DIRECTORY, R.PEOPLE_DIRECTORY],
        [R.ADMIN_USERS_DIRECTORY_CREATE, R.PEOPLE_DIRECTORY_CREATE],
        [R.ADMIN_EARLY_ACCESS_FEATURE, R.COMING_SOON_FEATURE],
        [R.ADMIN_REVIEWS_COMPARE_CYCLES, R.REVIEWS_COMPANY_COMPARE_CYCLES],
        [R.ADMIN_REVIEWS_WITH_CYCLE, R.REVIEWS_COMPANY_CYCLE],
        [R.YOUR_SURVEYS, R.YOUR_SURVEYS_YOUR],
        [R.REVIEWS, R.REVIEWS_YOUR],
    ];

    if (isFeatureEnabled('FEATURE_adminNavigationRefresh')) {
        return navRefreshDirects;
    } else {
        const reversedNavRefreshDirects: Redirect[] = navRefreshDirects
            .filter(([, newRoute]) => typeof newRoute === 'string')
            .map(([oldRoute, newRoute]) => [newRoute as string, oldRoute]);
        return [
            [RR.INSIGHTS, R.ADMIN_INSIGHTS],
            [RR.FEEDBACK_OVERVIEW, R.ADMIN_FEEDBACK_SELECT_CYCLE],
            [RR.FEEDBACK_OVERVIEW_WITH_CYCLE, R.ADMIN_FEEDBACK_WITH_CYCLE],
            [RR.REVIEW_OVERVIEW, R.ADMIN_REVIEWS_SELECT_CYCLE],
            [RR.REVIEW_OVERVIEW_WITH_CYCLE, R.ADMIN_REVIEWS_WITH_CYCLE],
            ...reversedNavRefreshDirects,
        ];
    }
}

function retainQuery(route: string): (props: RouteProps) => string {
    return ({ location }) => route + (location?.search ?? '');
}
